import { sendCodeFetch, verifyCodeFetch, graphicCodeFetch, loginFetch } from './services'


const ServiceApi = {
    sendCodeFetch,
    verifyCodeFetch,
    graphicCodeFetch,
    loginFetch,
}

export default ServiceApi